/**
 * Utilitaire pour décoder et vérifier les JWT
 */

interface DecodedJWT {
  sub: number;
  email: string;
  isSuperAdmin: boolean;
  iat: number;
  exp: number;
}

/**
 * Décoder un JWT sans vérifier la signature
 * (c'est OK car on ne fait que lire les données côté client)
 */
export const decodeJWT = (token: string): DecodedJWT | null => {
  try {
    const parts = token.split('.');
    if (parts.length !== 3) {
      return null;
    }

    // Décoder la partie payload (index 1)
    const decoded = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/'))
    );

    return decoded as DecodedJWT;
  } catch (error) {
    console.error('Erreur lors du décodage du JWT:', error);
    return null;
  }
};

/**
 * Vérifier si l'utilisateur est SuperAdmin
 */
export const isSuperAdmin = (): boolean => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    return false;
  }

  const decoded = decodeJWT(token);
  return decoded?.isSuperAdmin === true;
};

/**
 * Vérifier si l'utilisateur est connecté
 */
export const isLoggedIn = (): boolean => {
  const token = sessionStorage.getItem('accessToken');
  return !!token;
};

/**
 * Obtenir l'ID de l'utilisateur courant
 */
export const getCurrentUserId = (): number | null => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    return null;
  }

  const decoded = decodeJWT(token);
  return decoded?.sub ?? null;
};

/**
 * Obtenir l'email de l'utilisateur courant
 */
export const getCurrentUserEmail = (): string | null => {
  const token = sessionStorage.getItem('accessToken');
  if (!token) {
    return null;
  }

  const decoded = decodeJWT(token);
  return decoded?.email ?? null;
};
